import { ReactNode, useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Navigate, useLocation } from "react-router-dom";
import { loginRequest } from "./msalConfig";
import { LoadingScreen } from "../components/LoadingScreen";
import { SewerGate } from "../../modules/sewer-portal/SewerGate";

/**
 * Gate for authenticated routes. Redirects unauthenticated users to /login,
 * shows a loading state while MSAL is resolving its internal state.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();
  const location = useLocation();

  useEffect(() => {
    // Auto-trigger login if we're done with redirect handling and still not authenticated.
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: location.pathname + location.search
      });
    }
  }, [isAuthenticated, inProgress, instance, location]);

  if (inProgress !== InteractionStatus.None) {
    return <LoadingScreen message="Signing you in..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // A linked subcontractor is kept on their own portal (fails open — see SewerGate).
  return <SewerGate fallback={<LoadingScreen message="Loading…" />}>{children}</SewerGate>;
}
